import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGiftCard } from '@fortawesome/pro-regular-svg-icons';

export const SendAsGiftUnavailable = () => {
    return (
        <div
            className={`flex w-64 ml-auto mr-auto items-center mt-5 px-4 text-sm text-left text-grey-2`}
        >
            <FontAwesomeIcon className="mr-3 text-lg text-grey-3" icon={faGiftCard} />
            <div className=" text-sm text-left text-grey-2">
                Gifting is temporarily unavailable for this product.
            </div>
        </div>
    );
};
